<script setup lang="ts">
import { computed, ref } from 'vue'
// `useRoute` auto-importé de Nuxt, pas celui de vue-router : il ne bascule qu'une fois la nouvelle page affichée,
// sinon la sidebar change avant que la page sortante ait laissé place à la suivante
import SidebarDiffusion from './SidebarDiffusion.vue'

const route = useRoute()
const isDiffusion = computed(() => route.path.startsWith('/diffusion'))

const statut = ref<string | undefined>('Actif')
const statutItems = [
  'Actif',
  'Expertise',
  'Loué',
  'Vendu',
  'En attente de mandat',
  'Vente suspendue',
]

const owner = ref<string | undefined>(undefined)
const ownerItems = [
  'Jean Dupont',
  'Nathalie Martin',
  'Pierre Durand',
  'Sophie Bernard',
  'Paul Morel',
  'Julie Petit',
  'Luc Leroy',
  'Marie Dubois',
]

const city = ref<string | undefined>(undefined)
const { searchTerm: citySearchTerm, items: cityItems } = useLocaliteSearch()

const reference = ref('')

const transaction = ref<string | undefined>('Vente')
const transactionItems = ['Vente', 'Location', 'Viager']

// Critères additionnels (révélés via "+ de critères")
const category = ref<string | undefined>(undefined)
const categoryItems = ['Maison', 'Appartement', 'Terrain', 'Local commercial']
const surfaceMin = ref('')
const priceMax = ref('')

function onSubmit() {
  // À câbler avec la recherche
}

function onCancel() {
  statut.value = undefined
  owner.value = undefined
  city.value = undefined
  citySearchTerm.value = ''
  reference.value = ''
  transaction.value = undefined
  category.value = undefined
  surfaceMin.value = ''
  priceMax.value = ''
}
</script>

<template>
  <SidebarDiffusion v-if="isDiffusion" />
  <SearchSidebar
    v-else
    cancel-label="Réinitialiser"
    @submit="onSubmit"
    @cancel="onCancel"
  >
    <UFormField label="Statut">
      <USelectMenu v-model="statut" :items="statutItems" class="w-full" />
    </UFormField>

    <UFormField label="Propriétaire">
      <USelectMenu
        v-model="owner"
        :items="ownerItems"
        placeholder="Rechercher un propriétaire"
        class="w-full"
      />
    </UFormField>

    <UFormField label="Localité">
      <UInputMenu
        v-model="city"
        v-model:search-term="citySearchTerm"
        :items="cityItems"
        value-key="label"
        v-bind="LOCALITE_MENU_PROPS"
        placeholder="Rechercher une ville"
        icon="i-lucide-locate-fixed"
        class="w-full"
      >
        <template #item-label="{ item }">
          {{ item.label }}
          <span v-if="item.parent" class="text-muted"> → {{ item.parent }}</span>
        </template>
      </UInputMenu>
    </UFormField>

    <UFormField label="Référence">
      <UInput
        v-model="reference"
        placeholder="Réf."
        icon="i-lucide-refresh-ccw"
        class="w-full"
      />
    </UFormField>

    <UFormField label="Transaction">
      <USelectMenu v-model="transaction" :items="transactionItems" class="w-full" />
    </UFormField>

    <template #more>
      <UFormField label="Catégorie">
        <USelectMenu v-model="category" :items="categoryItems" class="w-full" />
      </UFormField>

      <UFormField label="Surface min.">
        <UInput v-model="surfaceMin" placeholder="m²" class="w-full" />
      </UFormField>

      <UFormField label="Prix max.">
        <UInput v-model="priceMax" placeholder="€" class="w-full" />
      </UFormField>
    </template>
  </SearchSidebar>
</template>
